import { LogOut, ShieldCheck, Compass } from "lucide-react";
import { UserAvatar } from "@/components/UserAvatar";

export const DashboardHeader = ({ firstName, name, picture, isAdmin, showTourReplay, onReplayTour, onLogout }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
    <div className="flex items-center gap-5" data-testid="dashboard-avatar">
      <UserAvatar picture={picture} name={name || firstName} size={64} testId="dashboard-avatar" />
      <div>
        <div className="section-tag mb-4">§ Member Dashboard</div>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
          Welcome back, <span className="italic text-[#B45309]">{firstName}</span>.
        </h1>
        {isAdmin && (
          <div data-testid="admin-preview-banner" className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 border border-[#F59E0B]/40 bg-[#F59E0B]/5 font-mono text-[10px] tracking-[0.25em] uppercase text-[#B45309]">
            <ShieldCheck size={12} /> Admin preview · Everything unlocked
          </div>
        )}
      </div>
    </div>
    <div className="flex items-center gap-4">
      {showTourReplay && (
        <button onClick={onReplayTour} data-testid="welcome-tour-replay" className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] hover:text-[#B45309] inline-flex items-center gap-2 transition-colors">
          <Compass size={12} /> Take the tour
        </button>
      )}
      <button onClick={onLogout} data-testid="dashboard-logout" className="btn-outline text-sm w-fit">
        <LogOut size={16} /> Sign out
      </button>
    </div>
  </div>
);
